<form [formGroup]="searchForm">
  <div>
    <mat-form-field>
      <mat-label>{{ title || "input-measurement-unit" | translate }}</mat-label>
      <input
        type="text"
        matInput
        [matAutocomplete]="autoComplete"
        formControlName="name"
        required
      />
      <mat-autocomplete autoActiveFirstOption #autoComplete="matAutocomplete">
        <mat-option
          *ngFor="let item of measurementUnits"
          (onSelectionChange)="handleUnitChange($event, item)"
          [value]="item.description"
          class="autocomplete"
        >
          {{ item.value }} - {{ item.description }}
        </mat-option>
      </mat-autocomplete>
      <mat-error *ngIf="!this.searchForm.valid">{{
        requiredText || "required-measurement-unit" | translate
      }}</mat-error>
    </mat-form-field>
  </div>
</form>
